export interface IColors {
    white: string
    black: string
    
    greyLight: string
    grey: string
    greyMedium: string
    greyDark: string
    greyNormal: string
    estadao: string
    estadaoLight: string
    estadaoDark: string
    estadaoBlue: string

    yellow: string

    red: string
    redDark: string
    green: string
}

const colors : IColors =  {
    white: '#fff',
    black: '#000',

    greyLight: '#f5f5f6',
    grey: '#9696a6',
    greyNormal: '#56565f',
    greyMedium: '#757582',
    greyDark: '#39393f',


    estadao: '#002fd8',
    estadaoLight: '#438bf3',
    estadaoDark: '#19519e',
    estadaoBlue: '#002052',



    yellow: '#f0bc00',

    red: '#f90921',
    redDark:'#a0001a',


    green: '#35a625',
}

export default colors